<template>
  <Modal
    ref="modal"
    title="Face"
    size="xs"
    @hide="onHide"
  >
    <div
      v-if="face"
      class="face-detail__header column items-center q-pa-sm bg-grey-2"
    >
      <q-img
        v-if="face.imageUrl"
        :src="face.imageUrl"
        :ratio="1"
        fit="cover"
        class="face-detail-card__image rounded-borders"
      />
      <q-icon
        v-else
        name="fa fa-user-circle"
        size="120px"
        color="grey-5"
      />
      <div
        v-if="face.person"
        class="text-body1 text-weight-medium q-mt-sm"
      >
        {{ face.person.label || 'Unnamed Person' }}
      </div>
      <div class="text-caption text-grey-6">
        {{ Math.round(face.confidence) }}% confidence
      </div>
    </div>

    <template v-slot:actions="{ hide }">
      <q-btn
        v-if="showViewPerson && face && face.person"
        icon="fa fa-user"
        label="View Person"
        color="primary"
        flat
        dense
        no-caps
        @click="viewPerson"
      />
      <q-space />
      <q-btn
        label="Close"
        flat
        @click="hide"
      />
    </template>
  </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Face } from '@/analysis/types';
import Modal from '@/components/modal/Modal.vue';

export default defineComponent({
  emits: ['view-person'],
  components: { Modal },
  props: {
    showViewPerson: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      face: null as Face | null,
    };
  },
  methods: {
    open(face: Face): void {
      this.face = face;
      (this.$refs.modal as any).show();
    },
    close(): void {
      (this.$refs.modal as any).hide();
    },
    onHide(): void {
      this.face = null;
    },
    viewPerson(): void {
      if (this.face && this.face.person) {
        this.$emit('view-person', this.face.person, this.close.bind(this));
      }
    },
  },
});
</script>

<style scoped>
.face-detail__header {
  margin: -16px -16px 0;
}

.face-detail-card__image {
  width: 100%;
  max-width: 380px;
  height: 380px;
}
</style>
